<template>
  <div>
    <jet-banner />
    <div
      class="min-h-screen flex flex-col justify-start md:justify-center items-center bg-custom-blue-light"
    >
      <div
        class="w-full max-w-xl md:max-w-lg mx-10 my-8 px-10 py-8 bg-white shadow-md overflow-hidden rounded-lg"
      >
        <div class="mb-10">
          <slot name="logo" />
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import JetBanner from '@/Components/ui/BannerHead.vue'
</script>
